import { Dialog, Box, Typography, Stack, Button } from '@mui/material';

import { currencyFormatter } from '../helpers';


function CollectPaymentDialog({ open, onClose, totalAmount, onCancel }) {
  const handleClose = (reason) => {
    if (reason !== "backdropClick") {
      onClose(reason);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <Box sx={{ padding: 4 }}>
        <Stack spacing={2} sx={{ textAlign: 'center' }}>
          <Typography variant='h4'>Waiting for payment...</Typography>
          <Typography variant='h6'>{currencyFormatter(totalAmount / 100)}</Typography>
          <Button variant='contained' color="error" onClick={onCancel}>Cancel</Button>
        </Stack>
      </Box>
    </Dialog>
  );
}

export default CollectPaymentDialog;
